<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="components"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading mr-auto">Ингредиенты</h2>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column label="Наименование" prop="name"/>
        <el-table-column label="Единица измерения" align="center">
          <template slot-scope="{row}">
            <span class="text-muted">{{ row.measure }}</span>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Ингредиенты'},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/ingredients.vue